/** ↑ ↑ ↓ ↓ ← → ← → B A */
export const KONAMI_SEQUENCE = [
  'arrowup',
  'arrowup',
  'arrowdown',
  'arrowdown',
  'arrowleft',
  'arrowright',
  'arrowleft',
  'arrowright',
  'b',
  'a',
];

/**
 * Returns a `(key) => void` that calls `onUnlock` once the full sequence
 * has been entered in order. A wrong key rewinds (but a stray "↑" still
 * counts as the start of a fresh attempt). Pure — no DOM.
 */
export function konamiHandler(onUnlock) {
  let i = 0;
  return (key) => {
    const k = String(key).toLowerCase();
    if (k === KONAMI_SEQUENCE[i]) {
      i += 1;
      if (i === KONAMI_SEQUENCE.length) {
        i = 0;
        onUnlock();
      }
    } else {
      i = k === KONAMI_SEQUENCE[0] ? 1 : 0;
    }
  };
}

/** Wire {@link konamiHandler} to window keydowns. Returns an unsubscribe. */
export function onKonami(onUnlock) {
  const step = konamiHandler(onUnlock);
  const listener = (e) => step(e.key);
  window.addEventListener('keydown', listener);
  return () => window.removeEventListener('keydown', listener);
}
